import { ApdmReadingGap } from '@euler/model/apdm';

const kLabels: Record<ApdmReadingGap, string> = {
  [ApdmReadingGap.Plate]: '车牌号',
  [ApdmReadingGap.ServiceDate]: '服务日期',
  [ApdmReadingGap.Items]: '服务项目',
};

export function readingGapLabel(gap: ApdmReadingGap): string {
  return kLabels[gap];
}
